<template>
  <div>
    <!--当没设置标书费-->
    <span v-if="!feeConfig.chargeType" class="text-danger">
      尚未设置，请联系客服设置{{ label }}
    </span>

    <!--为发布设置的时候，让用户输入-->
    <div v-else-if="feeConfig.chargeType === chargeTypeDict.COMPANY.value">
      <el-input-number
        v-model="formFee"
        class="left-input-number"
        style="width: 200px"
        :min="0"
        :max="99999999999.99"
        :controls="false"
        :precision="2"
        :placeholder="label"
      />
      <span style="display: inline-block; margin-left: 1rem;">
        元
      </span>
      <money-in-cn v-if="formFee" :money="formFee" />
    </div>

    <!--当为计费设置的时候，标书费根据预算总价按照公式获得回显-->
    <span v-else-if="feeConfig.chargeType === chargeTypeDict.CHARGE.value">
      <span v-if="showErr" class="text-danger">
        尚未设置，请联系客服设置{{ label }}
      </span>
      <span v-else>{{ formFee || formFee === 0 ? formFee : '-' }} 元</span>
    </span>

    <!--当为计费设置的时候，不收取-->
    <span v-else>不收取{{ label }}</span>
  </div>
</template>
<script>
import MoneyInCn from '@/components/common/MoneyInCn'

import { costSubjectDict, chargeTypeDict } from '@/dictionary/company'

export default {
  components: {
    MoneyInCn
  },

  model: {
    prop: 'fee',
    event: 'change'
  },

  props: {
    fee: {
      type: [String, Number, undefined],
      default: undefined
    },

    label: {
      type: String,
      default: ''
    },

    costSubject: {
      type: [String, Number],
      default: costSubjectDict.BOND.value
    },

    chargeConfig: {
      type: Array,
      default: () => []
    },

    // 估算
    budget: {
      type: [String, Number, undefined],
      default: undefined
    },

    // 是否是万元
    isWy: {
      type: Boolean,
      default: false
    },

    // 计算api
    computeApi: {
      type: Function,
      default: () => {}
    },

    // 项目类型
    projectType: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      chargeTypeDict,

      showErr: false,

      formFee: 0,
      feeConfig: {}
    }
  },

  watch: {
    formFee: {
      handler: function(val) {
        if (this.feeConfig.chargeType === chargeTypeDict.FREE.value) {
          this.$emit('change', 0)
          return
        }
        this.$emit('change', val)
      },
    },
    fee: {
      handler: function(val) {
        this.formFee = val
      },
      immediate: true
    },
    // 根据估算，当为计费方式时候
    budget: {
      handler: function(val) {
        if (
          val &&
          this.feeConfig.costSubject === this.costSubject &&
          this.feeConfig.chargeType === chargeTypeDict.CHARGE.value
        ) {
          this.getFee()
        }
      },
      immediate: true
    },

    chargeConfig: {
      handler: function(val) {
        this.feeConfig =
          this.chargeConfig.find(el => el.costSubject == this.costSubject) || {}
        if (this.feeConfig.chargeType === chargeTypeDict.FREE.value) {
          this.formFee = 0
        } else {
          this.getFee()
        }
      },
      immediate: true
    },

    projectType: {
      handler: function(val) {
        this.getFee()
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 当为计费方式时候，自动获取标书费
     */
    async getFee() {
      if (!this.budget || !this.projectType || !this.feeConfig.configId) {
        return
      }
      if (this.feeConfig.chargeType !== chargeTypeDict.CHARGE.value) {
        return
      }
      try {
        const submitData = {
          projectType: this.projectType
        }
        if (this.isWy) {
          submitData.budgetAmountWy = this.budget
        } else {
          submitData.budgetAmount = this.budget
        }
        const _data = await this.computeApi(submitData, this.feeConfig.configId)
        this.formFee = _data.data?.fee
        this.showErr = false
      } catch (err) {
        console.log(err.message || '获取费用信息失败')
        this.showErr = true
        // this.$message.error(err.message || '获取费用信息失败')
      }
    }
  }
}
</script>
